// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import APPROVE from "../../assets/Accepted.svg";
// Comonents Imports
// import { Button } from "../../commonComponents";
import AcceptanceGraphic from "../../assets/Acceptance-Graphic.png";

// import StatusDropdown from "../QuotationTopbar/StatusDropdown";

class DocAcceptanceAcceptedStatusUpdate extends Component {
  _onClose = () => {
    this.props.toggleModalPopUp("docAcceptanceConfirmationPopup", false);
  };

  render() {
    return (
      <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="docstatus-accptancereject-image">
            <div className="docstatus-confirm-text">
              <div className="doc-confirm-seal">
                <img
                  src={APPROVE}
                  alt="Approve badge"
                  className="document-sent-confirmation-image"
                />
              </div>
              <div className="docstatus-confirm-title">Awesome!</div>
              <div className="docstatus-accept-subtitle">
                You have just accepted and given your consent for this document.
              </div>
              <div className="acceptance-docstatus-confirm-footer">
                You can access this document any time using the link in the
                email.
              </div>
            </div>

            <img
              src={AcceptanceGraphic}
              alt="Revv"
              className="document-sent-confirmation-image"
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default DocAcceptanceAcceptedStatusUpdate;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocAcceptanceAcceptedStatusUpdate.js